import TableFilters from '@/components/component/Reuse/TableFilters/TableFilters.vue';
import { cloneDeep } from 'lodash';
import { getIamUsers, createUserGroup, getGroupDetailById, editUserGroup, getPermissionPolicies } from '@/libs/api/api';
import { message, loader } from '../../../../../libs/helper';
import constants from '@/libs/constant/constants';
import pageRoutes from '@/libs/constant/pageRoutes'
// import { loadResources } from 'i18next/dist/commonjs';

export default {
    name: 'CreateGroup',
    data() {
        return {
            isEdit: false,
            userData: [],
            usercolumns: ['name', 'user_type', 'active_groups', 'settings'],
            usertableSettings: {
                headings: {
                    name: 'Name',
                    user_type: '',
                    active_groups: ' Groups',
                    settings: '',
                },
                pagination: { show: true },
                perPage: 10,
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                // alwaysShowPerPageSelect:true,
                // perPageValues:["10","20","30"]
            },
            permissionData: [],
            permissioncolumns: ['permission_checkbox_all', 'policy_name', 'policy_type', 'description', 'settings'],
            permissiontableSettings: {
                headings: {
                    permission_checkbox_all: 'permission_checkbox_all',
                    policy_name: 'Policy Name',
                    policy_type: 'Type',
                    description: 'Description',
                    settings: '',
                },
                pagination: { show: true },
                perPage: 10,
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                // alwaysShowPerPageSelect:true,
                // perPageValues:["10","20","30"]
            },
            sort: true,
            currentPageUser: 1,
            skipUser: 0,
            previousPageUser: 1,
            sortUser: 'screen_name',
            orderUser: 'asc',
            selectedUser: 10,
            currentPagePermission: 1,
            skipPermission: 0,
            previousPagePermission: 1,
            sortPermission: 'name',
            orderPermission: 'desc',
            selectedPermission: 4,
            totalTableData: 0,
            searchValueUser: '',
            searchValuePermission: '',
            selectedEntriesUsers: [],
            selectedEntriesPermissions: [],
            group_name_input: '',
            userTableDataCount: null,
            permissionTableDataCount: null,
            limitUser: 25,
            limitPermission: 4,
            loadingTableData: false,
            isAllPerissionsMarked: false,
            createBtnDisabled: true,
            btnLoading: false,
            selectedTableFilters: {},
            tableFiltercategory: '',
            tableFilters: {},
            groupDetails: {},
        }
    },
    computed: {
        category() {
            return this.$store.getters.getType
        }
    },
    watch: {
        totaltableData(value) {
            this.totalPage = value
        },
        currentPage(value) {
            this.current = value
        },
        selectedValuePermission(value) {
            this.selectedPermission = value || this.previousPagePermission
        },
        selectedValue(value) {
            this.selecteduser = value || this.perPageUser
        },
        tableData(value) {
            this.rowsData = value
        },
        selectedTableFilters(value) {
            this.tableFilters = value
        },
        group_name_input(value) {
            this.group_name_input = value
            if (value == '' || value == undefined)
                this.createBtnDisabled = true
            else
                this.createBtnDisabled = false
        }
    },

    async created() {
        this.permissionTableDataCount = this.permissionData && this.permissionData.length;
    },
    beforeMount() {
    },

    async mounted() {
        if (this.$router.currentRoute.fullPath.includes('edit')) {
            this.isEdit = true
            let groupId = this.$router.currentRoute.params.id
            await this.fetchSingleGroupDetail(groupId)
        }
        else this.isEdit = false

        // call api to get all users list
        let orgID = this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id
        await this.fetchUserDetails(orgID);
        await this.fetchNewRecordPermission(this.skipPermission, this.limitPermission, this.sortPermission, this.orderPermission)
    },

    methods: {
        async fetchUserDetails(orgID) {
            loader(this, true)
            let body = { searchText: this.searchValueUser }
            let params = `?skip=${this.skipUser}&limit=${this.limitUser}&sort=${this.sortUser}&order=${this.orderUser}`
            await getIamUsers(orgID, params, body).then((res) => {
                let data = res && res.result.items
                if (data) {
                    this.userTableDataCount = res && res.result && res.result.items.total_count;
                    this.userData = data
                }
                else this.createBtnDisabled = true
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        gotoUserGroupList() {
            this.isEdit = false
            this.group_name_input = ''
            this.$router.push({ name: pageRoutes.iamUserGroup })
        },
        changeSortUser(sortingKey) {
            this.sortingOrderUser = this.sortingKeyUser !== sortingKey ? 'desc' : this.sortingOrderUser === 'desc' ? 'asc' : 'desc'
            this.sortingKeyUser = sortingKey
            this.sortingUser(this.categoryUser, this.sortingOrderUser, this.sortingKeyUser)
        },
        sortingUser(type, order, sort) {
            this.skipUser = 0
            this.orderUser = order
            this.currentPageUser = 1
            this.sortUser = sort
            this.fetchNewRecord(this.skipUser, this.limitUser, this.sortUser, this.orderUser)
        },
        changeSortPermission(sortingKey) {
            this.sortingOrderPermission = this.sortingKeyPermission !== sortingKey ? 'desc' : this.sortingOrderPermission === 'desc' ? 'asc' : 'desc'
            this.sortingKeyPermission = sortingKey
            this.sortingPermission(this.categoryPermission, this.sortingOrderPermission, this.sortingKeyPermission)
        },
        sortingPermission(type, order, sort) {
            this.skipPermission = 0
            this.orderPermission = order
            this.currentPagePermission = 1
            this.sortPermission = sort
            this.fetchNewRecordPermission(this.skipPermission, this.limitPermission, this.sortPermission, this.orderPermission)
        },
        fetchNewRecord: async function (skip, limit, sort, order) {
            //call api and set data to table
            let body = { searchText: this.searchValueUser }
            let params = `?skip=${skip}&limit=${limit}&sort=${sort}&order=${order}`
            let orgID = this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id
            loader(this, true)
            await getIamUsers(orgID, params, body).then((response) => {
                if (response && response.result)
                    this.userData = response.result.items
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        fetchNewRecordPermission: async function (skip, limit, sort, order) {
            loader(this, true)
            let params = `?skip=${skip}&limit=${limit}&sort=${sort}&order=${order}`
            console.log(params)
            let body = { searchText: this.searchValueUser }
            await getPermissionPolicies(body).then((res) => {
                let data = res.items
                if (data) {
                    this.permissionData = data
                    this.permissionData.filter((item) => {
                        if (item.isdefault === true)
                            this.selectedEntriesPermissions.push(item._id)
                    });
                }
                loader(this, false)
            }).catch((error) => {
                message(this, constants.messageType.ERROR, (error))
                loader(this, false)
            })
        },
        setTableFilters(filters) {
            this.selectedTableFilters = cloneDeep(filters)
            this.$store.dispatch('setTableFilters', filters)
            this.filterCall()
        },
        filterCall() {
            this.changePage(1)
        },
        changePageUser(currentPage) {
            this.previousPageUser = this.currentPageUser
            this.currentPageUser = currentPage
            this.skipUser = (currentPage - 1) * this.selectedUser
            this.fetchNewRecord(this.skipUser, this.limitUser, this.sortUser, this.orderUser)
        },
        changePagePermission(currentPage) {
            this.previousPagePermission = this.currentPagePermission
            this.currentPagePermission = currentPage
            this.skipPermission = (currentPage - 1) * this.selectedPermission
            this.fetchNewRecordPermission(this.skipPermission, this.limitPermission, this.sortPermission, this.orderPermission)
        },
        handleCheckBoxSelectUser(row) {
            let id = row.entity_id
            if (!this.selectedEntriesUsers.includes(id)) {
                this.selectedEntriesUsers.push(id)
            } else {
                const index = this.selectedEntriesUsers.indexOf(id)
                if (index > -1) {
                    this.selectedEntriesUsers.splice(index, 1);
                }
            }
        },
        handleCheckBoxSelectPermission(row) {
            let id = row
            if (!this.selectedEntriesPermissions.includes(id)) {
                this.selectedEntriesPermissions.push(id)
            } else {
                const index = this.selectedEntriesPermissions.indexOf(id)
                if (index > -1) {
                    this.selectedEntriesPermissions.splice(index, 1);
                }
            }
        },
        async querySearchForUser(query, cb) {
            if (query === undefined || query === '' || query.length < 2) {
                return
            }
            let searchResult = []
            try {
                let body = { searchText: query }
                let params = `?skip=${0}&limit=${this.limitUser}&sort=${this.sort}&order=${this.order}`
                let id = this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id
                searchResult = await getIamUsers(id, params, body)
                this.userTableDataCount = searchResult && searchResult.result.total_count;
                this.userData = searchResult.result.items

            } catch (error) {
                return error
            }
            // call callback function to return suggestion objects
            cb(searchResult.result.items);
        },
        searchGroup(item) {
            this.searchValueUser = item.userDetails[0].screen_name
        },
        handlePolicySearch(item) {
            this.searchValuePermission = item.policy_name
        },
        querySearchForPermission(query, cb) {
            if (query) {
                let results = this.permissionData.filter((c) => {
                    return c.policy_name.toLowerCase().includes(query.toLowerCase())
                })
                cb(results)
            }
        },
        toggleAllForPermissions(event) {
            // if (!this.showBulkUpdate) return
            // this.selectedEntriesPermissions = []
            this.isAllPerissionsMarked = event
            if (this.isAllPerissionsMarked) {
                this.$refs.groupPermissionTable.data.map((row) => {
                    if (!row.isdefault && this.searchValuePermission !== row._id) {
                        this.selectedEntriesPermissions.push(row._id)
                    }
                })
            } else {
                this.selectedEntriesPermissions = []
                this.permissionData.filter((item) => {
                    if (item.isdefault === true)
                        this.selectedEntriesPermissions.push(item._id)
                });
            }
        },

        handleSubmitGroup() {
            this.btnLoading = true
            let name = this.group_name_input
            loader(this, true)
            if (name == '' && name == undefined) {
                message(this, constants.messageType.ERROR, ('Group Name not entered'))
                this.btnLoading = false
                loader(this, false)
            }
            else {
                // make payload and params data
                let name = this.group_name_input
                let groupId = this.isEdit ? this.$router.currentRoute.params.id : null
                let payload = {}
                payload.entity_id = this.$attrs.currentOrganisation._id
                payload.entity_type = constants.ORGANISATIONS.ORGANISATION
                payload.group_name = name
                payload.group_members = [...this.selectedEntriesUsers]
                payload.group_policy = [...this.selectedEntriesPermissions]
                if (this.isEdit) {
                    this.editGroup(groupId, payload)
                }
                else this.createGroup(payload);
            }
        },
        async clearSearchInputUser() {
            this.searchValueUser = ''
            let orgID = this.$attrs.currentOrganisation && this.$attrs.currentOrganisation._id
            this.skipUser = 0
            this.currentPageUser = 1
            await this.fetchUserDetails(orgID);
        },
        /* setTableFilters(filters) {
            console.log('setTableFilters', filters)
            this.selectedTableFilters = cloneDeep(filters)
            this.$store.dispatch('setTableFilters', filters)
            this.filterCall()
        }, */
        /* filterCall() {
            this.changePage(1)
        }, */
        applyFilters() {
            /*  let filtersToApply = {}
             if (!isEmpty(this.selectedTableFilters)) {
                 if (this.selectedTableFilters.city && this.selectedTableFilters.city.length > 0) {
                     filtersToApply.city = this.selectedTableFilters.city
                 }
                 if (this.selectedTableFilters.name && this.selectedTableFilters.name.length > 0) {
                     filtersToApply.name = this.selectedTableFilters.name
                 }
             } 
             this.selectedTableFilters = filtersToApply
             return this.selectedTableFilters */
        },
        async createGroup(payload) {
            await createUserGroup(payload).then((res) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.SUCCESS, (res.message))
                this.gotoUserGroupList()
            }).catch((error) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.ERROR, (error))
            })
        },
        async editGroup(groupId, payload) {
            await editUserGroup(groupId, payload).then((res) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.SUCCESS, (res.message))
                this.gotoUserGroupList()
            }).catch((error) => {
                this.btnLoading = false
                loader(this, false)
                message(this, constants.messageType.ERROR, (error))
            })
        },
        async fetchSingleGroupDetail(orgId) {
            await getGroupDetailById(orgId).then((res) => {
                let data = res && res.length && res[0] || {}
                this.groupDetails = data
                this.group_name_input = data.group_name
                if (data && data.userDetails && data.userDetails.length) {
                    this.selectedEntriesUsers = data.userDetails.map((item) => item._id)
                }
                if (data && data.group_policy && data.group_policy.length) {
                    this.selectedEntriesPermissions = data.group_policy
                }
            }).catch((err) => {
                message(this, constants.messageType.ERROR, (err))
            })
        },
        isItemChecked(item) {
            let isPresent;
            isPresent = this.selectedEntriesUsers.includes(item && item.entity_id)
            return isPresent
        }
    },
    components: {
        TableFilters,
    }
}